/* eslint-disable @typescript-eslint/no-explicit-any */
import { get, getServiceResponse, handleClientError, getServiceResponseError } from '../lib'
import saveAs from 'file-saver'

type _QueryVSDBDownload = {
  type: 'vsdb',
  id: number,
  scriptId: number
}
type _QueryDownloadDownload = {
  type: 'download',
  id: number
}
type _QueryUploadFileVersionDownload = {
  type: 'uploadFileVersion',
  id: number
}
type _QueryUserDownload = {
  type: 'user',
  id: number
}

export interface ScriptResponseCollection {
  id: number
  name: string
}
export interface ScriptResponseDownloadFile {
  id: number
  name: string
  size: number
}
export interface ScriptResponse {
  id: number
  coremini16: boolean
  coremini32: boolean
  coreminiSize: number
  dateCreated: string
  downloadFile: ScriptResponseDownloadFile
  vsdbName: string
  vspyVersion: string
  collections: ScriptResponseCollection[]
}

type RequestType = _QueryDownloadDownload | _QueryVSDBDownload | _QueryUploadFileVersionDownload | _QueryUserDownload

interface RequestResponseType {
  expires: string,
  token: string
}

export const requestDownloader = async (args: RequestType): Promise<RequestResponseType> => {
    return get<RequestResponseType>({
      path: '/api/v1/downloader/request',
      query: args
    })
}

//Note: for others, should pass through search filter
export const downloadFile = async (args: RequestType): Promise<void> => {
  try {
    const {token} = await requestDownloader(args)
    
    saveAs(`/api/v1/downloader/retrieve?token=${token}`)
  } catch(e) {
    console.error('Error processing downloader download file', e)
    throw e
  }
}

//Note: for others, should pass through search filter
export const getUploadFileVersion = async (id: number): Promise<Blob> => {
  try {
    const {token} = await requestDownloader({
      type: 'uploadFileVersion',
      id
    })
    
    const res = await fetch(`/api/v1/downloader/retrieve?token=${token}`)

    if(!res.ok) {
      //will throw the error
      const e = await getServiceResponseError(res)
      throw e
    }

    return res.blob()

  } catch(e) {
    console.error('Error processing downloader download file', e)
    throw e
  }
}

export const getDownloadScript = (scriptId: number) => {
  return get<ScriptResponse>({
    path: `/api/v1/scripts/${scriptId}`
  })
}
